import View from './View';

export { default as View, getChromecastExpandedControllerStyles } from './View';

export default View;
